export function initTrustedTypesPolicy(): void {
  const tt = (window as any).trustedTypes;
  if (!tt?.createPolicy) return;

  tt.createPolicy('default', {
    createHTML: (input: string) => input,
    createScript: (input: string) => input,
    createScriptURL: (input: string) => input,
  });
}
